/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { FxIdApplicationDataConnectionsDriversDriverOutputDtoMeta } from './FxIdApplicationDataConnectionsDriversDriverOutputDtoMeta';
import {
    FxIdApplicationDataConnectionsDriversDriverOutputDtoMetaFromJSON,
    FxIdApplicationDataConnectionsDriversDriverOutputDtoMetaFromJSONTyped,
    FxIdApplicationDataConnectionsDriversDriverOutputDtoMetaToJSON,
    FxIdApplicationDataConnectionsDriversDriverOutputDtoMetaToJSONTyped,
} from './FxIdApplicationDataConnectionsDriversDriverOutputDtoMeta';
import type { FxIdApplicationDataConnectionsDriversDriverOutputDtoStatistics } from './FxIdApplicationDataConnectionsDriversDriverOutputDtoStatistics';
import {
    FxIdApplicationDataConnectionsDriversDriverOutputDtoStatisticsFromJSON,
    FxIdApplicationDataConnectionsDriversDriverOutputDtoStatisticsFromJSONTyped,
    FxIdApplicationDataConnectionsDriversDriverOutputDtoStatisticsToJSON,
    FxIdApplicationDataConnectionsDriversDriverOutputDtoStatisticsToJSONTyped,
} from './FxIdApplicationDataConnectionsDriversDriverOutputDtoStatistics';

/**
 * 
 * @export
 * @interface FxIdApplicationDataConnectionsDriversDriverOutputDto
 */
export interface FxIdApplicationDataConnectionsDriversDriverOutputDto {
    /**
     * 
     * @type {Array<FxIdApplicationDataConnectionsDriversDriverOutputDtoMeta>}
     * @memberof FxIdApplicationDataConnectionsDriversDriverOutputDto
     */
    Meta: Array<FxIdApplicationDataConnectionsDriversDriverOutputDtoMeta>;
    /**
     * 
     * @type {Array<{ [key: string]: any; }>}
     * @memberof FxIdApplicationDataConnectionsDriversDriverOutputDto
     */
    Data: Array<{ [key: string]: any; }>;
    /**
     * 
     * @type {number}
     * @memberof FxIdApplicationDataConnectionsDriversDriverOutputDto
     */
    Rows: number;
    /**
     * 
     * @type {FxIdApplicationDataConnectionsDriversDriverOutputDtoStatistics}
     * @memberof FxIdApplicationDataConnectionsDriversDriverOutputDto
     */
    Statistics: FxIdApplicationDataConnectionsDriversDriverOutputDtoStatistics;
}

/**
 * Check if a given object implements the FxIdApplicationDataConnectionsDriversDriverOutputDto interface.
 */
export function instanceOfFxIdApplicationDataConnectionsDriversDriverOutputDto(value: object): value is FxIdApplicationDataConnectionsDriversDriverOutputDto {
    if (!('Meta' in value) || value['Meta'] === undefined) return false;
    if (!('Data' in value) || value['Data'] === undefined) return false;
    if (!('Rows' in value) || value['Rows'] === undefined) return false;
    if (!('Statistics' in value) || value['Statistics'] === undefined) return false;
    return true;
}

export function FxIdApplicationDataConnectionsDriversDriverOutputDtoFromJSON(json: any): FxIdApplicationDataConnectionsDriversDriverOutputDto {
    return FxIdApplicationDataConnectionsDriversDriverOutputDtoFromJSONTyped(json, false);
}

export function FxIdApplicationDataConnectionsDriversDriverOutputDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationDataConnectionsDriversDriverOutputDto {
    if (json == null) {
        return json;
    }
    return {
        
        'Meta': ((json['Meta'] as Array<any>).map(FxIdApplicationDataConnectionsDriversDriverOutputDtoMetaFromJSON)),
        'Data': json['Data'],
        'Rows': json['Rows'],
        'Statistics': FxIdApplicationDataConnectionsDriversDriverOutputDtoStatisticsFromJSON(json['Statistics']),
    };
}

export function FxIdApplicationDataConnectionsDriversDriverOutputDtoToJSON(json: any): FxIdApplicationDataConnectionsDriversDriverOutputDto {
    return FxIdApplicationDataConnectionsDriversDriverOutputDtoToJSONTyped(json, false);
}

export function FxIdApplicationDataConnectionsDriversDriverOutputDtoToJSONTyped(value?: FxIdApplicationDataConnectionsDriversDriverOutputDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'Meta': ((value['Meta'] as Array<any>).map(FxIdApplicationDataConnectionsDriversDriverOutputDtoMetaToJSON)),
        'Data': value['Data'],
        'Rows': value['Rows'],
        'Statistics': FxIdApplicationDataConnectionsDriversDriverOutputDtoStatisticsToJSON(value['Statistics']),
    };
}

